import { type MCPServerInfo } from '../../types';

const AwsDocumentationServer: MCPServerInfo = {
  serverId: 'AWS_DOCUMENTATION',
  name: 'AWS Documentation',
  slug: 'aws-documentation',
  description: 'AWS Documentation MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl:
      'mcp/public.ecr.aws/awslabs-mcp/awslabs/aws-documentation-mcp-server:sha-00083602a8f70cb8e5b833fa84a8de11b96d8be9',
    commitSha: '5d04a96',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default AwsDocumentationServer;
